import React from "react";

import { Button, CircularProgress } from "@mui/material";

const ReportActionButton = ({ loading, onClick, icon, label }) => {
  return (
    <Button
      size="large"
      onClick={onClick}
      disabled={loading}
      fullWidth
      sx={{
        minWidth: { xs: "63%" },
        width: "10%",
        borderRadius: "10px",
        textTransform: "none",
        borderColor: "#1976d2",
        color: "#1976d2",
        display: "flex",
        alignItems: "center",
        "&:hover": {
          borderColor: "#1565c0",
          color: "#1565c0",
          backgroundColor: "transparent",
        },
      }}
    >
      {loading ? (
        <CircularProgress size={20} sx={{ marginRight: "10px" }} />
      ) : (
        React.cloneElement(icon, {
          width: "18px",
          height: "18px",
          style: { marginRight: "10px" },
        })
      )}
      {label}
    </Button>
  );
};

export default ReportActionButton;
